/** @jsx jsx */
import { HTMLTable } from '@blueprintjs/core';
import { css, jsx } from '@emotion/core';
import { useHistory } from 'react-router-dom';
import TableHeaderCell from '../../../components/TableHeaderCell';
import { OrganisationDetailPageFragment } from '../../../generated/graphql';
import OrganisationCompanionListItem from './OrganisationCompanionListItem';

type OrganisationCompanionListProps = {
  companions: OrganisationDetailPageFragment['companions'];
};

const OrganisationCompanionList = ({ companions }: OrganisationCompanionListProps) => {
  const history = useHistory();

  return (
    <HTMLTable interactive condensed css={styles.table}>
      <thead>
        <tr>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Besonderheiten</TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {companions.map((companion) => (
          <OrganisationCompanionListItem
            key={companion.id}
            item={companion}
            onClick={() => history.push(`/companions/${companion.id}`)}
          />
        ))}
      </tbody>
    </HTMLTable>
  );
};

export default OrganisationCompanionList;

const styles = {
  table: css`
    width: 100%;
  `,
};
